export const TRADE_IN_PAGE_SLUG = 'trade-in';

// product slider constants

export const SET_PRODUCT_SLIDER_LIST = 'setProductSliderList';
export const SET_PRODUCT_SLIDER_POSITION = 'setProductSliderPosition';

// banner container constants

export const SET_BANNER_VIEW = 'setBannerView';

export const MAIN_PAGE_PATHNAME = '/shop';
export const BRAND_ZONE_PATHNAME = '/shop/novinki';

export const PAGES_WITHOUT_TRADE_IN = ['xiaomi'];
